<template lang="pug">
  button.btn-link.transparent-btn.xs-f-small.max-at-tweak.color-mr-purple.new-address-btn(@click="newAddressModal()" data-mr-ass="account-add-address")
    i.icon-pos-circle
    | Add address
  
</template>

<script>
  export default {
    name: "AddNewAddressBtn",

    methods: {
      newAddressModal() {
        this.$emit('new-address-click');
        this.$store.dispatch('addressBook/editAddressModal');
      },
    }
   }
</script>

<style scoped lang="stylus">
  button
    padding 1em 2em

</style>